<template>
  <!-- 报警列表 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="报警级别">
              <a-select v-model="query.alarmLevel"
                        placeholder="请选择报警级别"
                        allow-clear>
                <a-select-option value="报警"> 报警</a-select-option>
                <a-select-option value="预警"> 预警</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="处理状态">
              <a-select v-model="query.isDispose"
                        placeholder="请选择处理状态"
                        allow-clear>
                <a-select-option :value="0"> 未处理 </a-select-option>
                <a-select-option :value="1"> 已处理</a-select-option>
                <a-select-option :value="2"> 已忽略</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="报警类型">
              <a-select v-model="query.alarmType"
                        placeholder="请选择报警类型"
                        allow-clear>
                <a-select-option v-for="(item, index) in parameterList"
                                 :key="index"
                                 :value="item">
                  {{ item }}
                </a-select-option>
                <!-- <a-select-option value="上限预警"> 上限预警</a-select-option>
                <a-select-option value="下限预警"> 下限预警</a-select-option>
                <a-select-option value="数据丢失"> 数据丢失</a-select-option>
                <a-select-option value="下限报警"> 上限报警</a-select-option>
                <a-select-option value="下限报警"> 下限报警</a-select-option>
                <a-select-option value="中断"> 中断</a-select-option> -->
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6"
                 :sm="12">
            <a-form-item label="设备编号">
              <a-input v-model="query.flowMeterNo"
                       placeholder="请输入设备编号"
                       allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="12"
                 :sm="12">
            <a-form-item label="最近一次报警时间">
              <a-range-picker v-model="collectionTime"
                              :show-time="{ format: 'HH:mm:ss' }"
                              format="YYYY-MM-DD HH:mm:ss"
                              :placeholder="['最近一次报警开始时间', '最近一次报警结束时间']"
                              @change="collectionOnChange" />
            </a-form-item>
          </a-col>
          <a-col :md="8"
                 :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary"
                        @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px"
                        @click="resetList">重置</a-button>
              <a-button type="danger"
                        style="margin-left: 8px"
                        @click="deleteSelectRow">删除</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id"
             :scroll="{ x: 2000 }"
             bordered
             :data-source="list"
             :columns="columns"
             :loading="dataListLoading"
             :pagination="pagination"
             :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
             @change="pageChange"
             :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)">
      <!-- <span slot="disposeTime" slot-scope="text" v-if="text !== null">{{ moment(text).format('YYYY-MM-DD') }}</span> -->
      <span slot="isDispose"
            slot-scope="text">
        <a-tag color="rgb(255, 99, 71)"
               v-if="text == 0"> 未处理 </a-tag>
        <a-tag color="rgb(50, 205, 50)"
               v-else-if="text == 1"> 已处理 </a-tag>
        <a-tag color="#1890ff"
               v-else> 已忽略 </a-tag>
      </span>
      <span slot="alarmLevel"
            slot-scope="text">
        <a-tag color="rgb(255, 0, 0)"
               v-if="text == '报警'"> 报警 </a-tag>
        <a-tag color="rgb(255, 165, 0)"
               v-else-if="text == '预警'"> 预警 </a-tag>
      </span>
      <span slot="action"
            slot-scope="text, record">
        <a @click="PublishTask(record)"
           :disabled="record.isDispose !== 0">处理</a>
        <a style="margin-left: 12px"
           :disabled="record.isDispose !== 0"
           @click="LoseSightOf(record.id)">忽略</a>
      </span>
    </a-table>
    <!-- <a-modal title="报警处理" width="50%" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <p>
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="处理人">
            <a-input v-decorator="['disposeName', { rules: [{ required: true, message: '请输入处理人!' }] }]"/>
          </a-form-item>
          <a-form-item label="处理结果">
            <a-select
              v-decorator="['isDispose', { rules: [{ required: true, message: '请选择处理结果!' }] }]"
              placeholder="选择处理结果"
              @change="handleSelectChange"
            >
              <a-select-option v-for="(item, index) in dealList" :key="index" :value="item.value">
                {{ item.title }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </p>
    </a-modal> -->
    <task-modal ref="TaskModal"
                @handleOk="update"></task-modal>
  </a-card>
</template>

<script>
import pick from 'lodash.pick'
import mixinViewModule from '@/mixin/common'
import TaskModal from '@/views/maintenance/TaskManagement/modules/TaskModal'
export default {
  components: {
    TaskModal,
  },
  mixins: [mixinViewModule],
  name: 'userRemoteAlarmData',
  data () {
    return {
      pushTime: [],
      collectionTime: [],
      parameterList: [],
      currntId: '',
      visible: false,
      dealList: [
        { title: '未处理', value: 0 },
        { title: '已处理', value: 1 },
        { title: '已忽略', value: 2 },
      ],
      selectedRows: [],
      msg: '(0,1) 含义 : >0 并且<1   [0,1] 含义 : >=0  并且 <=1      (0  含义 : >0',
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
      currentId: '',
      queryUrl: '/pipe-network/remote_water_meter_alarm_messages/page',
      deleteUrl: '/pipe-network/remote_water_meter_alarm_messages',
      addOrUpdateUrl: '/pipe-network/remote_water_meter_alarm_messages',
      //   queryOneUrl: '/pipe-network/remote_water_meter_warning_values',
      query: {
        sysTab: 0,
        alarmLevel: '',
        alarmType: '',
        isDispose: 0,
        tenantId: this.$store.state.user.info.tenantId,
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '设备编号',
          width: 120,
          dataIndex: 'flowMeterNo',
        },
        {
          title: '报警位置',
          width: 200,
          dataIndex: 'msgAddress',
          ellipsis: true,
        },
        {
          title: '报警级别',
          width: 100,
          dataIndex: 'alarmLevel',
          scopedSlots: { customRender: 'alarmLevel' },
        },
        {
          title: '处理状态',
          width: 100,
          dataIndex: 'isDispose',
          scopedSlots: { customRender: 'isDispose' },
        },

        {
          title: '开始报警时间',
          width: 200,
          dataIndex: 'createTime',
        },
        {
          title: '最近一次报警时间',
          width: 200,
          dataIndex: 'updateTime',
        },
        {
          title: '报警类型',
          width: 100,
          dataIndex: 'alarmType',
          ellipsis: true,
          // scopedSlots: { customRender: 'type'},
        },
        {
          title: '报警指标',
          width: 100,
          dataIndex: 'alarmIndex',
          align: 'alarmIndex',
          ellipsis: true,
        },
        {
          title: '指标当前报警值',
          width: 200,
          dataIndex: 'prewarningValue',
        },
        {
          title: '参考值',
          width: 100,
          dataIndex: 'refValue',
        },
        {
          title: '报警次数',
          width: 100,
          dataIndex: 'num',
        },
        {
          title: 'X坐标',
          width: 130,
          dataIndex: 'longitude',
        },
        {
          title: 'Y坐标',
          width: 130,
          dataIndex: 'latitude',
        },
        {
          title: '处理人',
          width: 100,
          ellipsis: true,
          dataIndex: 'disposeName',
        },
        {
          title: '处理时间',
          width: 200,
          dataIndex: 'disposeTime',
          scopedSlots: { customRender: 'disposeTime' },
        },
        {
          title: '操作',
          width: 120,
          dataIndex: 'action',
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },

  created () {
    this.alarmTy()
  },
  methods: {
    alarmTy () {
      let params = {
        sysTab: 0,
      }
      this.$http.get('/pipe-network/remote_water_meter_alarm_messages/group/type', { params }).then((res) => {
        console.log(res.data, '123')
        this.parameterList = res.data
      })
    },
    collectionOnChange (value, dateString) {
      this.query.startTime = dateString[0]
      this.query.endTime = dateString[1]
    },
    PublishTask (record) {
      this.currentId = record.id
      this.$refs.TaskModal.edit(record)
    },
    LoseSightOf (id) {
      let params = {
        id: id,
        isDispose: 2,
      }
      console.log(id, 'ddd')
      this.$confirm({
        title: '忽略',
        content: `您确定要忽略此条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/remote_water_meter_alarm_messages', params).then((res) => {
            this.isDispose == 2
            this.queryList()
            this.$message.success(`忽略此条数据成功！`)
          })
        },
      })
    },
    update () {
      let data = {
        id: this.currentId,
        isDispose: 1,
      }
      this.$http.put(this.addOrUpdateUrl, data).then(({ data }) => {
        this.queryList()
      })
    },
    handleOk (e) {
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          let data = {
            id: this.currntId,
            ...values,
          }
          this.$http.put(this.addOrUpdateUrl, data).then((data) => {

            if (data.code == 0) {
              this.$message.success(data.message)
              this.queryList()
              this.addOrUpdateForm.resetFields()
              this.visible = false
            } else {
              this.$message.error(data.message)
            }
          })
        }
      })
    },
    handleCancel (e) {
      this.visible = false
    },
    handleSelectChange (value) {
      console.log(value)
      this.addOrUpdateForm.setFieldsValue({
        isDispose: value,
      })
    },
    // 重置
    resetList () {
      this.pushTime = []
      this.pagination.current = 1
      this.collectionTime = []
      this.selectedRows = []
      this.query = {
        sysTab: 0,
        alarmLevel: '',
        alarmType: '',
        isDispose: 0,
      }
      this.queryList()
    },
  },
  watch: {},
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}
.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/ .ant-table-thead > tr > th > {
  text-align: center;
}

/deep/ .ant-table-tbody > tr > td {
  text-align: center;
}
</style>
